import { connect } from '../../../../common/react-redux';
import { QUIZ_SESSIONS_FETCH_CALL } from '@instructure/quiz-common';
import { getQuizSessions } from '../../../api/quizSessions';
import { openTray } from '../../../../common/actions/moderation';
import ModerateTablePresenter from './presenter';
import { openModal } from '../../../../common/actions/modal';
import { addSuccess } from '../../../../common/actions/alerts';
import { getQuizSessionsByIds } from '../../../../common/selectors/quizSessions';
export function mapStateToProps(state, ownProps) {
  var isFetching = state.getIn(['calls', QUIZ_SESSIONS_FETCH_CALL, 'requestStatus']) === 'calling';
  var quiz_ids = ownProps.inProgressData.flatMap(function (user) {
    return user.quizSessionIds;
  });
  var quizSessionsData = getQuizSessionsByIds(state, quiz_ids).filter(function (qs) {
    return qs.isLoaded() && !qs.pending();
  });
  var quizSessionIdsAndUsers = ownProps.inProgressData.flatMap(function (user) {
    return user.quizSessionIds.map(function (quiz_id) {
      return {
        name: user.name,
        id: quiz_id
      };
    });
  });
  return {
    isFetching: isFetching,
    quizSessionsData: quizSessionsData,
    quizSessionIdsAndUsers: quizSessionIdsAndUsers,
    hasSessionTimeLimit: state.getIn(['quizzes', ownProps.quizId, 'hasTimeLimit']),
    sessionTimeLimitInSeconds: state.getIn(['quizzes', ownProps.quizId, 'sessionTimeLimitInSeconds'])
  };
}
export var mapDispatchToProps = {
  getQuizSessions: getQuizSessions,
  openTray: openTray,
  openModal: openModal,
  addSuccess: addSuccess
};
export var ModerateTable = connect(mapStateToProps, mapDispatchToProps)(ModerateTablePresenter);
export default ModerateTable;